module.exports = __webpack_public_path__ + "img/verkkoasiointi_etusivu.5930eee2.jpg";